// extracted by mini-css-extract-plugin
export default {"calendarLink":"AddToCalendar_calendarLink__N-PGZ"};